import React from "react";

function useLocalStorage<Type>(
  key: string,
  initialValue: Type,
): [Type, React.Dispatch<Type>] {
  const [value, setValue] = React.useState(() => {
    try {
      return JSON.parse(localStorage.getItem(key) || String(initialValue));
    } catch {
      return initialValue;
    }
  });

  React.useEffect(
    () => localStorage.setItem(key, JSON.stringify(value)),
    [key, value],
  );

  return [value, setValue];
}

export { useLocalStorage };
